<template>
  <div class="tabs" :id="tabsContainerId">
    <!-- Tab Navigation -->
    <div :class="navWrapperClass">
      <ul class="nav nav-tabs" role="tablist" :id="tabsNavId">
        <li
          v-for="(tab, index) in tabs"
          :class="['nav-item', tab.titleClass]"
          :key="index"
        >
          <a
            :class="['nav-link', { active: activeTabIndex === index }]"
            @click.prevent="handleTabClick(index, tab.onClick)"
            href="#"
          >
            <slot :name="tab.titleHtml" />
          </a>
        </li>
      </ul>
    </div>
    <!-- Tab Content -->
    <div :class="['tab-content', contentClass]" :id="tabContentId">
      <div
        v-for="(tab, index) in tabs"
        :class="['tab-pane fade', { show: activeTabIndex === index, active: activeTabIndex === index }]"
        :id="generateTabPaneId(tab)"
        :key="index"
      >
        <slot :name="`tab-${index}`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BTabsKariermu',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    navWrapperClass: {
      type: [Array, Object],
      default: () => []
    },
    contentClass: {
      type: [Array, Object],
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 0
    },
    onActivateTab: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      activeTabIndex: this.modelValue,
      tabsNavId: '',
      tabContentId: '',
      tabsContainerId: ''
    }
  },
  watch: {
    activeTab (newIndex) {
      this.activeTabIndex = newIndex
    },
    tabsContainerId: {
      immediate: true,
      handler () {
        this.activeTabIndex = this.activeTab
      }
    }
  },
  methods: {
    randomId () {
      const prefix = '__BTK__' // boostrap tab kariermu
      const randomNumber = Math.floor(1000 + Math.random() * 9000) // generate 4 digit number
      return `${prefix}${randomNumber}`
    },
    generateId () {
      this.tabsContainerId = this.randomId()
      this.tabsNavId = `${this.tabsContainerId}__tab_controls`
      this.tabContentId = `${this.tabsContainerId}__tab_container`
    },
    generateTabPaneId (tab) {
      return this.tabsContainerId + '__' + tab.titleHtml + '__' + 'tab_pane'
    },
    handleTabClick (newTab, customHandler) {
      const currentTab = this.activeTabIndex

      if (typeof customHandler === 'function') {
        customHandler()
      }
      if (typeof this.onActivateTab === 'function') {
        this.$emit(
          'activate-tab',
          newTab,
          currentTab,
          (allow) => {
            if (allow) {
              this.activeTabIndex = newTab
            }
          }
        )
      } else {
        this.activeTabIndex = currentTab
      }
    }
  },
  mounted () {
    this.generateId()
  }
}
</script>
